import { TextAreaFormik } from '@strata/react-inputs';
import { HomeScreen, UpdatesSection } from '@strata/react-page-templates';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';
import { validationStrings } from '@strata/strata-ui-strings';
import dayjs from 'dayjs';
import * as Yup from 'yup';

import { CardArray } from 'pages/homeScreenMessaging/CardArray';
import {
    ApplicationInputs,
    DisplayInput,
    PublishDateInput,
} from 'pages/homeScreenMessaging/HomeScreenFormInputs';
import { HomeScreenMessageForm } from 'pages/homeScreenMessaging/HomeScreenMessageForm';

const EmptySection = { messages: [''] };

const UpdateTypeDisplayTextMap = {
    [UpdatesSection.Type.FEATURE]: 'Feature',
    [UpdatesSection.Type.ENHANCE]: 'Enhancement',
    [UpdatesSection.Type.BUG_FIX]: 'Bug Fix',
};

const UpdateTypeOptions = Object.entries(UpdateTypeDisplayTextMap).map(([value, text]) => ({
    value,
    text,
}));

const formContent = () => (
    <>
        <CardArray
            name="message"
            title="Section"
            cardClassName="sds_update-details__card--section"
            deleteDialogBodyText="Are you sure you want to delete this Section and its Message(s)?"
            newArrayValue={EmptySection}
        >
            {(sectionCardProps) => (
                <>
                    <RadioButtonGroupFormik
                        name={`${sectionCardProps.name}.update_type`}
                        label="Update Type"
                        required
                        disabled={sectionCardProps.readOnly}
                        options={UpdateTypeOptions}
                    />
                    <CardArray
                        name={`${sectionCardProps.name}.messages`}
                        title="Message"
                        cardClassName="sds_update-details__card--message"
                        deleteDialogBodyText="Are you sure you want to delete this Message?"
                        newArrayValue=""
                        readOnly={sectionCardProps.readOnly}
                    >
                        {(messageCardProps) => (
                            <TextAreaFormik
                                id={messageCardProps.name}
                                label="Message"
                                required
                                disabled={messageCardProps.readOnly}
                            />
                        )}
                    </CardArray>
                </>
            )}
        </CardArray>
        <PublishDateInput messageType={HomeScreen.MessageType.UPDATE} />
        <ApplicationInputs />
        <DisplayInput />
    </>
);

const previewContent = (values) => (
    <UpdatesSection
        updates={[
            {
                publish_date: dayjs(values.publish_date || undefined).toISOString(),
                message: values.message?.map((section) => ({
                    update_type: section.update_type,
                    messages: section.messages?.[0] ? section.messages : ['Update message text.'],
                })),
            },
        ]}
    />
);

export const UpdateDetails = () => (
    <HomeScreenMessageForm
        formTitle="Update"
        listPageUrl="/home-screen-messaging/updates"
        formatInitialValues={(message) => ({
            message: message?.message ?? [EmptySection],
            ...PublishDateInput.initialValues(message),
            ...ApplicationInputs.initialValues(message),
            ...DisplayInput.initialValues(message),
        })}
        validationSchema={Yup.object({
            message: Yup.array(
                Yup.object({
                    update_type: Yup.string().required(
                        validationStrings.requiredField.errorMessage,
                    ),
                    messages: Yup.array(
                        Yup.string().required(validationStrings.requiredField.errorMessage),
                    ).min(1, validationStrings.requiredField.errorMessage),
                }),
            ).min(1, validationStrings.requiredField.errorMessage),
            ...PublishDateInput.validationSchema,
            ...ApplicationInputs.validationSchema,
            ...DisplayInput.validationSchema,
        })}
        formatSubmitBody={(values) => ({
            message_type: HomeScreen.MessageType.UPDATE,
            message: values.message,
            ...PublishDateInput.submitValues(values),
            ...ApplicationInputs.submitValues(values),
            ...DisplayInput.submitValues(values),
        })}
        formContent={formContent}
        previewContent={previewContent}
    />
);
